import React, { useState, useEffect, useRef } from 'react';
import menu from '../assets/menu.png';
import nabeel from '../assets/svg/nabeel4.svg';
import { Link as RouterLink } from 'react-router-dom';
import { HashLink as NavLink } from 'react-router-hash-link';
import Sidebar from './Sidebar';
import User from '../assets/icons/Sed-01-512.png';
import Notifications from '@material-ui/icons/Notifications';
import { useDispatch, useSelector } from 'react-redux';
import { signOutUser } from '../redux/actions/auth';
import { useHistory } from 'react-router-dom';
import { fetchNavProfileCards } from '../redux/actions/cardsActions';
import UserAccountModal from '../Modals/UserAccountModal';
import NotificationsModal from '../Modals/NotificationsModal';

function ClickOutSide(ref, callback, when) {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  });
  function handler(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      savedCallback.current();
    }
  }
  useEffect(() => {
    if (when) {
      document.addEventListener('click', handler);
      return () => document.removeEventListener('click', handler);
    }
  });
}
const Navbar = () => {
  const [menuOpen, toggleMenu] = useState(false);
  const [userModel, setUserModel] = useState(true);
  const [userNotifications, setUserNotifications] = useState(false);
  const navModels = useRef();
  const navUser = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const noti = useRef();

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const profile = useSelector((state) => state.userProfileReducer.userProfile);

  const handleSignOut = () => {
    dispatch(signOutUser(history));
    setUserModel(!userModel);
  };
  const toggler = () => {
    toggleMenu(!menuOpen);
  };
  const showUserModel = () => {
    setUserModel(false);
  };
  const hideUserModel = () => {
    setUserModel(true);
  };
  const hideNotifications = () => {
    setUserNotifications(false);
  };
  const showNotifications = () => {
    setUserNotifications(true);
  };
  ClickOutSide(navModels, hideNotifications, userNotifications);
  ClickOutSide(navUser, hideUserModel, !userModel);

  const currentUser = useSelector((state) => state.authReducer.userId);

  const navcards = useSelector((state) => state.cardsReducer.navcards);

  useEffect(() => {
    if (isAuthenticated && profile) {
      dispatch(fetchNavProfileCards(currentUser));
    }
    const interval = setInterval(() => {
      if (isAuthenticated && profile) {
        dispatch(fetchNavProfileCards(currentUser));
      }
    }, 50000);
    return () => clearInterval(interval);
  }, []);
  const converDate = (timestamp) => {
    if (timestamp) {
      let fireTime = new Date(timestamp.toDate());

      let newDate = new Date();

      let elaps = (newDate.getTime() - fireTime.getTime()) / 1000;
      if (elaps > 86400) {
        return Math.floor(elaps / 86400) + ' أيام';
      } else if (elaps > 3600) {
        return Math.floor((elaps / 3600) % 24) + ' ساعات';
      } else if (elaps > 60) {
        return Math.floor((elaps / 60) % 60) + ' دقائق';
      } else {
        return Math.floor(elaps % 60) + ' ثواني';
      }
    }
  };

  return (
    <div className=''>
      <nav id='nav' className='flex justify-between items-center relative'>
        <div className='py-10 px-4 lg:hidden '>
          <button
            onClick={() => toggleMenu(!menuOpen)}
            className=' block focus:outline-none'
          >
            <img className='' src={menu} alt='Menu' />
          </button>
        </div>
        <div className='hidden lg:block lg:justify-end relative ml-8'>
          <RouterLink to='/'>
            <img src={nabeel} width='100' height='100' alt='logo' />
          </RouterLink>
        </div>
        <div className='hidden lg:flex  font-semibold ml-10 '>
          <RouterLink
            to='/'
            className='pr-2 lg:px-3  hover:border border-blue-600 rounded'
          >
            الرئيسية
          </RouterLink>
          <RouterLink to='/Dashboard' className='pr-2 lg:px-3 '>
            خدماتنا
          </RouterLink>
          <RouterLink to='/contact-us' className='pr-2 lg:px-3'>
            إتصل بنا
          </RouterLink>
          <RouterLink to='/ask-for-help' className='pr-2 lg:px-3'>
            اطلب المساعدة
          </RouterLink>
          <NavLink
            // activeClass="active"
            to='/about-us'
            spy='true'
            smooth={true}
            offset={0}
            duration={500}
            className='pr-2 lg:px-3 cursor-pointer '
          >
            من نحن ؟
          </NavLink>
        </div>
        {menuOpen ? <Sidebar toggle={toggler} /> : null}
        <div>
          {!isAuthenticated ? (
            <div className='sm:py-10 sm:pr-4  flex flex-row '>
              <button
                type='button'
                className=' bg-transparent  n-green  sm:py-2 sm:pr-2 px-2 font-semibold focus:outline-none'
                id='sign-in'
              >
                <RouterLink to='/sign-in'>تسجيل دخول</RouterLink>
              </button>
              <button
                type='button'
                className=' bg-transparent  n-green  sm:py-2 sm:pr-2 px-2 py-1 font-semibold
             border border-green-600 hover:border-transparent rounded-full focus:outline-none mx-1'
              >
                <RouterLink to='/sign-up'>انشاء حساب</RouterLink>
              </button>
            </div>
          ) : (
            <div className='sm:py-10 sm:pr-4  flex flex-row  z-40'>
              <div className='pt-3 px-6'>
                <Notifications
                  onClick={showNotifications}
                  className='cursor-pointer pb-0 pt-1 md:pt-2 md:pb-0 mr-2'
                  alt='Notifications'
                  fontSize='large'
                  style={{ color: 'black' }}
                />
              </div>
              <div
                className={`block lg:hidden md:justify-end relative ml- mr-3 mb-2`}
              >
                <RouterLink to='/'>
                  <img src={nabeel} width='65' height='65' alt='logo' />
                </RouterLink>
              </div>

              <div onClick={showUserModel} className='lg:flex hidden'>
                {profile ? (
                  <img
                    src={profile.imgUrl || User}
                    alt='person'
                    className='sm:w-16 w-16 mr-8 cursor-pointer rounded-full'
                  />
                ) : (
                  <img
                    src={User}
                    alt='person'
                    className='sm:w-16 w-16 mr-8 cursor-pointer rounded-full'
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <UserAccountModal
          userModel={userModel}
          navUser={navUser}
          showUserModel={showUserModel}
          handleSignOut={handleSignOut}
        />
      </nav>
      <NotificationsModal
        userNotifications={userNotifications}
        hideNotifications={hideNotifications}
        navModels={navModels}
        noti={noti}
        navcards={navcards}
        currentUser={currentUser}
        converDate={converDate}
      />
    </div>
  );
};

export default Navbar;
